module.exports = __webpack_public_path__ + "img/ic_sha_shui.c58db6b0.png";